/* eslint-disable no-unused-vars, no-undef */
const lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy'
})
